import { render } from "./ImagesModal.vue?vue&type=template&id=5f13f8ee&scoped=true"
import script from "./ImagesModal.vue?vue&type=script&lang=js"
export * from "./ImagesModal.vue?vue&type=script&lang=js"

import "./ImagesModal.vue?vue&type=style&index=0&id=5f13f8ee&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1770887991853013682/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f13f8ee"]])

export default __exports__